<app-modal
  [title]="getTitle()"
  [saveButtonName]="getSaveButtonName()"
  [cancelButtonName]="getCancelButtonName()"
  (save)="add()"
  [shouldSaveBeDisabled]="form.invalid"
>
  <ng-container body>
    @if (data) {
      <main>
        <form [formGroup]="form">
          <app-emu-input formControlName="value" [name]="label"></app-emu-input>
        </form>
      </main>
    }
  </ng-container>
</app-modal>
